import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorResponse } from './ErrorResponse';
import { HrMaxPrice } from './HrMaxPrice';
import { mapHrMaxPrice } from './mapHrMaxPrice';

export interface Result {
	hrMaxPrice: HrMaxPrice;
}

export const findHrMaxPrice = async (client: ApiClient, userId: string, groupId: string): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/hr-max-price');
	return client
		.fetch(url.expand({ userId, groupId }))
		.then((response) => response.json())
		.then((response) => ({
			hrMaxPrice: mapHrMaxPrice(response.hrMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
};
